// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1WBbp","label":"Radio_label__3izzx","checkMark":"Radio_checkMark__3dzin","disabled":"Radio_disabled__3hwET"};